import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { indexPendingInvoices } from "~/modules/billing/api/pendingInvoice/pendingInvoiceApiDispatchers.ts";
import { INVOICES_BASE_QUERY_KEY } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";

export const All_PENDING_INVOICES_QUERY_KEY = [INVOICES_BASE_QUERY_KEY, "pending"];

export const useAllPendingInvoices = () => useQuery({
		queryKey: All_PENDING_INVOICES_QUERY_KEY,
		queryFn: () => indexPendingInvoices().then(getDataFromResponse),
	},
);